const removeNonNumeric = (inputString) => {
   let result = '';
   for (let i = 0; i < inputString.length; i++) {
      const char = inputString[i];
      if (char >= '0' && char <= '9') {
         result += char;
      }
   }

   return result;
}

export function init() {
   const register = {
      form: document.getElementById('deviation-form'),
      submit: document.getElementById('deviation-form-submit'),
      loading: document.getElementById('deviation-form-loading'),
      accountNumber: document.getElementById('accountNumber'),
   };
   
   // set specific listener for account number
   if (register.accountNumber) {
      const accountNumberLength = 11;

      register.accountNumber.addEventListener('keyup', event => {
         event.target.value = removeNonNumeric(event.target.value);
   
         // limit to 11 digits
         if (event.target.value.length > accountNumberLength)
            event.target.value = event.target.value.slice(0, accountNumberLength);
   
         return event.target.value;
      });
   }

   // register submission
   if (register.form) {
      register.form.addEventListener('submit', () => {
         if (register.form.checkValidity()) {
            register.submit.disabled = true;
            register.submit.classList.add('hidden');
            register.loading.classList.remove('hidden');
         }
      });
   }
}
